import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const ToastAlert = ({
  show,
  setShow,
  message,
  variant = 'success',
  position = 'middle-center', // custom position logic
}) => {
  const centerPosition = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
  };

  return (
    <ToastContainer
      className="p-3"
      style={position === 'middle-center' ? centerPosition : { position: 'fixed' }}
    >
      <Toast
        bg={variant}
        show={show}
        onClose={() => setShow(false)}
        delay={3000}
        autohide
      >
        <Toast.Body className="text-white fs-5 px-4 py-3 text-center">
          {message}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastAlert;
